//后厨接口

import request from '../request';

//出餐通知
export const reqTrigger = (id) => request({ url:`/admin/chef/${id}`, method:'get' });

//查询全部数据
export const reqGetAllData = () => request({ url:'/admin/chef/all', method:'get' });

//新增
export const reqAddData = (data) => request({ url:'/admin/chef/save', method:'post', data });

//调整状态
export const reqUpdateChefStatus = (status, id) => request({ url:`/admin/chef/chefStatus/${status}/${id}`, method:'post' });

//调整状态
export const reqUpdateDishStatus = (status, id) => request({ url:`/admin/chef/dishStatus/${status}/${id}`, method:'post' });

//明细表新增菜品
export const reqAddDishData = (data) => request({ url:'/admin/chef/add', method:'post', data });

//退菜状态
// export const reqUpdateReturnStatus = (orderNo, name) => request({ url:`/admin/chef/dish/return/${orderNo}/${name}`, method:'post' });
export const reqDeleteData = (orderNo, name) => request({ url:`/admin/chef/dish/return/${orderNo}/${name}`, method:'post' });
